// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--b3cf4";
export var fb = "style-module--fb--d6e71";
export var ico = "style-module--ico--f40e3";
export var name = "style-module--name--966b7";
export var screen2 = "style-module--screen2--57472";
export var title = "style-module--title--de625";